import { useMutation } from "@tanstack/react-query";
import { postCheckHprExist } from "apis";

const usePostCheckHprExist = () => {
  return useMutation(postCheckHprExist);
};

export default usePostCheckHprExist;